module.exports = require("./dist/react-pixi.module".concat(process.env.NODE_ENV === 'development' ? '-dev' : ''));